/**
 * @generated SignedSource<<86a5cd7eb22cde3262f246e638dd75f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowInner_issueEdge$data = {
  readonly issueError?: {
    readonly " $fragmentSpreads": FragmentRefs<"remoteIssueErrorRow_nativeIssueTable">;
  } | null | undefined;
  readonly node: {
    readonly id: string;
    readonly isHighlightedIssueRow: boolean | null | undefined;
    readonly issueId: string;
    readonly " $fragmentSpreads": FragmentRefs<"BeforeFirstCell">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRowWithFragments_issueEdge">;
  readonly " $fragmentType": "RowInner_issueEdge";
};
export type RowInner_issueEdge$key = {
  readonly " $data"?: RowInner_issueEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_issueEdge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "RowInner_issueEdge",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isLinkRelationshipFieldEnabled",
          "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        {
          "kind": "Variable",
          "name": "shouldQueryHasChildren",
          "variableName": "shouldQueryHasChildren"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRowWithFragments_issueEdge"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "issueId"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isReparentingEnabled",
              "variableName": "isReparentingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "BeforeFirstCell"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isHighlightedIssueRow"
            }
          ]
        }
      ]
    },
    {
      "condition": "isRemoteLinkedIssuesEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "issueError",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "remoteIssueErrorRow_nativeIssueTable"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "72b6c32de647f01cd45e824ded332d3f";

export default node;
